module.exports = __webpack_public_path__ + "static/pensjonat-glowne-photo02_thumb-9a781308049cb1a076ff20eefd788f9a.jpg";